import { Star } from 'lucide-react';

const testimonials = [
  {
    quote: "RepriScan m'a permis d'éliminer 3 dossiers non pertinents en une semaine. J'aurais perdu des mois sans cet outil.",
    author: 'Marc D.',
    role: 'Repreneur Indépendant',
    rating: 5,
  },
  {
    quote: "Enfin un outil simple qui me donne une vue claire avant de m'engager. Le score et les recommandations sont précieux.",
    author: 'Sophie L.',
    role: 'Cadre en reconversion',
    rating: 5,
  },
  {
    quote: "Le prédiagnostic est rapide et les exports PDF sont très pro. Mon banquier apprécie la clarté des synthèses.",
    author: 'Thomas B.',
    role: 'Repreneur Serial',
    rating: 5,
  },
];

export function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 bg-card">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Ce qu'en disent nos utilisateurs
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Des repreneurs comme vous qui ont gagné du temps grâce à RepriScan.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="p-6 bg-background rounded-xl border"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-score-medium text-score-medium" />
                ))}
              </div>
              
              {/* Quote */}
              <blockquote className="text-sm mb-4 leading-relaxed">
                "{testimonial.quote}"
              </blockquote>
              
              {/* Author */}
              <div>
                <p className="font-semibold text-sm">{testimonial.author}</p>
                <p className="text-xs text-muted-foreground">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
